var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4005,
    transform: "translate(-160 -52)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 18.7846 0 13.1769 2.41154 9C3.99137 6.26365 6.26365 3.99137 9 2.41154C13.1769 0 18.7846 0 30 0C41.2154 0 46.8231 0 51 2.41154C53.7363 3.99137 56.0086 6.26365 57.5885 9C60 13.1769 60 18.7846 60 30C60 41.2154 60 46.8231 57.5885 51C56.0086 53.7363 53.7363 56.0086 51 57.5885C46.8231 60 41.2154 60 30 60C18.7846 60 13.1769 60 9 57.5885C6.26365 56.0086 3.99137 53.7363 2.41154 51C0 46.8231 0 41.2154 0 30Z",
    fill: "#B5CF84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5992 30.6001C15.6169 30.6001 13.1992 28.1824 13.1992 25.2001L13.1992 21.6001C13.1992 21.2687 13.4678 21.0001 13.7992 21.0001L32.3992 21.0001L32.3992 30.6001L18.5992 30.6001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1953 16.2001C22.1953 13.2177 24.613 10.8 27.5953 10.8H31.1953C31.5267 10.8 31.7953 11.0687 31.7953 11.4V46.8C31.7953 47.1314 31.5267 47.4 31.1953 47.4H27.5953C24.613 47.4 22.1953 44.9824 22.1953 42V16.2001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5977 34.2H35.9977V46.8C35.9977 47.1313 36.2663 47.4 36.5977 47.4H40.1977C43.18 47.4 45.5977 44.9823 45.5977 42V34.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5977 34.5C45.5977 32.7272 45.2485 30.9717 44.57 29.3338C43.8916 27.6959 42.8972 26.2076 41.6436 24.9541C40.39 23.7005 38.9018 22.7061 37.2639 22.0276C35.626 21.3492 33.8705 21 32.0977 21L32.0977 30.5925C32.6108 30.5925 33.1189 30.6936 33.593 30.8899C34.0671 31.0863 34.4978 31.3741 34.8607 31.737C35.2235 32.0998 35.5114 32.5306 35.7077 33.0047C35.9041 33.4787 36.0052 33.9869 36.0052 34.5H45.5977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4005,
    fill: "white",
    transform: "translate(-160 -52)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2675594045daace519fec1ce0d8c54e4.svg";
export { ForwardRef as ReactComponent };